<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="90%"
      @close="close"
    >
      <el-form ref="formRef" label-width="120px" :model="form">
        <div class="row-wrap">
          <el-row :gutter="20">
            <el-col :span="3">分店</el-col>
            <el-col :span="3">酒店</el-col>
            <el-col :span="3">房型</el-col>
            <el-col :span="3">数量</el-col>
            <el-col :span="5">日期</el-col>
            <el-col :span="3">状态</el-col>
            <el-col :span="4">操作</el-col>
          </el-row>
        </div>
        <div v-for="(item, index) in form" :key="index" class="form-wrap">
          <el-row :gutter="20">
            <el-col :span="3">
              <!-- 门店 -->
              <el-select
                v-model="item.branchId"
                placeholder="请选择门店"
                clearable
              >
                <el-option
                  v-for="item in branchList"
                  :key="item.branchId"
                  :label="item.title"
                  :value="item.branchId"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <!-- 酒店 -->

              <el-select
                v-model="item.hotelId"
                placeholder="请选择酒店"
                clearable
              >
                <el-option
                  v-for="item in hotelList"
                  :key="item.hotelId"
                  :label="item.title"
                  :value="item.hotelId"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select v-model="item.roomTypeId" placeholder="选择房型">
                <el-option
                  v-for="item in roomTypeList"
                  :key="item.roomTypeId"
                  :label="item.title"
                  :value="item.roomTypeId"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-input-number :min="0" v-model="item.volume" />
            </el-col>
            <el-col :span="5">
              <el-date-picker
                v-model="item.date"
                type="daterange"
                size="small"
                value-format="YYYY-MM-DD"
                placeholder="选择日期"
              ></el-date-picker>
            </el-col>
            <el-col :span="3">
              <el-switch
                v-model="item.state"
                active-text="正常"
                inactive-text="关房"
              />
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="add">添加</el-button>
              <el-button v-if="index != 0" type="danger" @click="del(index)">
                删除
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { setupVolume } from '@/api/room'
import { getAllBranchs } from '@/api/branch'
import { ref, reactive, getCurrentInstance } from 'vue'
import commomFunction from '../roomPrice/common'
import getHotel from '../hotel'
import lodash from 'lodash'
export default {
  name: 'RoomCountEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const branchList = reactive([])
    const { roomTypeList, rateCodeList, enumerateDaysBetweenDates } =
      commomFunction()
    const form = reactive([
      {
        branchId: '',
        hotelId: '',
        roomTypeId: '',
        date: null,
        volume: '',
        state: true,
      },
    ])
    const { hotelList } = getHotel()
    const showEdit = async () => {
      title.value = '设置房量'
      getAllBranchList()
      dialogFormVisible.value = true
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
    }
    const close = (formRef) => {
      form.length = 0
      add()
      formReset(formRef)
      dialogFormVisible.value = false
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const add = () => {
      form.push({
        branchId: '',
        otelId: '',
        roomTypeId: '',
        date: '',
        volume: '',
        state: true,
      })
    }
    const del = (index) => {
      form.splice(index, 1)
    }
    const save = (formRef) => {
      const _form = lodash.cloneDeep(form)
      try {
        _form.forEach((e) => {
          if (!e.branchId) {
            throw '请选择门店'
          }
          if (!e.hotelId) {
            throw '请选择酒店'
          }
          if (!e.roomTypeId) {
            throw '请选择房型'
          }
          if (!e.volume) {
            throw '请填写数量'
          }
          if (!e.date) {
            throw '请选择日期'
          }
          e.state = e.state ? 1 : 2
        })
      } catch (error) {
        return proxy.$message.warning(error)
      }
      //计算得出每个日期区间的日期分别设置每个日期的房量
      const finalData = []
      _form.forEach((e) => {
        const startDate = e.date[0]
        const endDate = e.date[1]
        const roomTypeId = e.roomTypeId
        const volume = e.volume
        const state = e.state
        const branchId = e.branchId
        const hotelId = e.hotelId
        const dayList = enumerateDaysBetweenDates(startDate, endDate)
        dayList.forEach((f) => {
          finalData.push({
            date: f,
            roomTypeId,
            volume,
            state,
            branchId,
            hotelId,
          })
        })
      })
      proxy.$baseConfirm(`你确定要提交房量吗`, null, async () => {
        await setupVolume({ volumeList: finalData })
        proxy.$baseMessage(
          `设置房量成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        emit('fetch-data')
        close(formRef)
      })
    }
    return {
      title,
      formRef,
      form,
      roomTypeList,
      rateCodeList,
      branchList,
      dialogFormVisible,
      hotelList,
      showEdit,
      add,
      del,
      close,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
.row-wrap {
  padding: 16px 0;
}
.form-wrap {
  padding: 20px 0;
}
</style>
